<template>
    <order-timeline-box
        :title="__('general.prepared')"
        :message="tileMessage"
        :timestamp="logsByState.hasOwnProperty(OrderState.ReadyForPickup) ? logsByState[OrderState.ReadyForPickup].created_at : ''"
        :complete="isComplete"
        :spinner="isLoading"
        icon="fa-cubes"
    >
        <button class="btn btn-success" @click="$emit('transition', OrderState.ReadyForPickup)" :disabled="isLoading">
            <i class="fas fa-cubes"/>
            {{ __('actions.order.transition_to.pickup') }}
        </button>
    </order-timeline-box>
</template>

<script>
import OrderTimelineBox from '@components/Orders/Timeline/OrderTimelineBox.vue';
import {OrderState} from '@composables/orderStates';

export default {
    components: {OrderTimelineBox},

    props: {
        order: Object,
        users: Object,
    },

    computed: {
        OrderState() {
            return OrderState;
        },

        logsByState(){
            return this.order.logs_by_state;
        },

        tileMessage() {
            if (this.logsByState.hasOwnProperty(OrderState.ReadyForPickup)) {
                return this.users[this.logsByState[OrderState.ReadyForPickup].issuer_uid]
            }

            return '';
        },

        isComplete() {
            return this.logsByState.hasOwnProperty(OrderState.ReadyForPickup)
                || this.logsByState.hasOwnProperty(OrderState.Cancelled)
                || this.logsByState.hasOwnProperty(OrderState.Rejected)
                || this.logsByState.hasOwnProperty(OrderState.Refunded);
        },

        isLoading() {
            return !this.isComplete && this.order.state === OrderState.WaitForIntegration;
        },
    },
};
</script>
